module.exports = {
	"header": "Spotin partners with authors",
	"date": "2022/11/24",
	"imgSrc": "21.png",
	"imgAlt": "Spotin partners with authors",
	"ingress": "By: Norrbottens Affärer (in Swedish)",
	"externalLink": "https://affarerinorr.se/nyheter/2022/november/spotin-samarbetar-med-forfattare/"
};


//////////////////
// WEBPACK FOOTER
// ./pages/media/21/article.json
// module id = 91
// module chunks = 0